<div
  *ngrxLet="projectFacde.getTransportScenarioListForRetail$ as getTransportScenarioListForRetail"
  class="modal-content"
  piqetAngularDraggable
>
  <div class="organization-modal">
    <div>
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
      <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>

    <div class="modal-body">
      <form
        [formGroup]="projectPackRetailForm"
        (keydown.enter)="$event.preventDefault()"
        [ngClass]="{ 'disabled-popup': !showEdit }"
      >
        <!-- add form group -->
        <div formGroupName="transportationDetailForm" class="row">
          <div class="col-12">
            <label class="subTitleName">{{ transportHeader }}</label>
          </div>

          <!-- Transport buttons -->
          <div class="col-12 levelDivs">
            <ul class="nav nav-pills nav-justified buttonTab" id="myTab" role="tablist">
              <li
                class="nav-item d-flex justify-content-around"
                role="presentation"
                (click)="manualLocation(data)"
                *ngFor="let data of wholeData"
              >
                <button
                  id="location-tab"
                  [ngClass]="
                    selectedBox.id === data.transportationId &&
                    (selectLocation || selectDistance || selectCustom)
                      ? 'nav-link active'
                      : 'nav-link'
                  "
                  type="button"
                >
                  <div class="image">
                    <img
                      [src]="data.img"
                      [height]="data.heightImg"
                      [width]="data.widthImg"
                      alt=""
                    />
                  </div>
                  <div class="displayName">
                    <span
                      [ngClass]="
                        selectedBox.id === data.transportationId &&
                        (selectLocation || selectDistance || selectCustom)
                          ? 'active'
                          : ''
                      "
                      >{{ data.displayName }}</span
                    >
                  </div>
                </button>
              </li>
            </ul>
          </div>

          <!-- Transport button Content -->
          <div class="tab-content checkbox-margin">
            <!-- Location -->
            <div class="fade show" *ngIf="selectLocation">
              <div class="row levelDivs">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 customTruckCheckBox">
                  <div
                    class="d-flex checkBoxAlienMent"
                    *ngIf="getTransportScenarioListForRetail.length > 0"
                  >
                    <div>
                      <input
                        type="checkbox"
                        class="chkOverview"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="isCustomTruck"
                        (change)="chnageCustomTruck($event)"
                      />
                    </div>
                    <div>
                      <label class="checkbox-style">Custom truck</label>
                    </div>
                  </div>
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input type="checkbox" class="chkOverview" (change)="showPorts($event)" />
                    </div>
                    <div>
                      <label class="checkbox-style">Show only ports</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                  >
                    <div></div>
                    <div *ngIf="isCustomTruck && showEdit && showCustomTruckAccess">
                      <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                        ><span class="redirectLinkText">Add custom truck</span></a
                      >
                      <a
                        class="setLinkIconPosition"
                        target="_blank"
                        replaceUrl="true"
                        routerLink="custom/customTrucks"
                      >
                        <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                      </a>
                      <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                        ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <label
                  *ngIf="!!isValidPort && getTransportScenarioListForRetail.length > 0"
                  class="input-error port-err"
                  >{{ isValidPort }}</label
                >
              </div>
              <ng-container *ngrxLet="projectFacde.distanceErrorProject$ as distanceErrorProject">
                <div class="mt-3" *ngIf="distanceErrorProject !== ''">
                  <span class="input-error-distance">{{ distanceErrorProject }}</span>
                </div>
              </ng-container>
              <div class="grid-div">
                <ng-container *ngIf="getTransportScenarioListForRetail?.length">
                  <piqet-angular-portlet
                    [columnDefs]="processColumnDef"
                    [frameworkComponents]="frameworkComponents"
                    [gridData]="getTransportScenarioListForRetail"
                    [hideSearch]="true"
                    [hidePagination]="true"
                    [gridName]="'pack retail manual location'"
                    (inlineDataEditEvent)="inlineDataEditEvent($event)"
                  >
                  </piqet-angular-portlet>
                </ng-container>
              </div>
              <ng-template #other_content>
                <div class="row" *ngIf="getTransportScenarioListForRetail?.length == 0">
                  <div class="col-6">
                    <div class="d-flex justify-content-end ms-5">
                      <p class="highlights" placeholder="Origin">
                        Select locations with "(Port)" for shipping
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group required inputLables">
                      <div class="ng-autocomplete custom-autocomplete">
                        <ng-autocomplete
                          #autoForOrigin
                          [data]="selectedCities"
                          [searchKeyword]="keyword"
                          (inputChanged)="onSearch($event)"
                          historyIdentifier="selectedCities"
                          (selected)="selectEvent($event)"
                          [itemTemplate]="itemTemplate"
                          placeholder="Origin"
                          class="supplierdrpdown"
                          [notFoundTemplate]="notFoundTemplate"
                          formControlName="Origin"
                          (inputCleared)="onClearSearch($event)"
                          [isLoading]="isLoading"
                          (scrolledToEnd)="onScroll()"
                          [(ngModel)]="keywordAuto"
                          (keydown)="onKeyDownEvent($event)"
                        >
                        </ng-autocomplete>
                        <ng-template #itemTemplate let-item>
                          <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                        </ng-template>

                        <ng-template #notFoundTemplate let-notFound>
                          <div [innerHTML]="notFound"></div>
                        </ng-template>
                      </div>
                    </div>
                    <div
                      *ngIf="
                        setOriginsubmitted &&
                        !this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty(
                          'name'
                        )
                      "
                      class="input-error mt-4"
                    >
                      Select city from list.
                    </div>
                  </div>
                  <div class="col-sm-1 aligniconQuestion">
                    <span
                      placement="auto"
                      tooltipClass="sku-tooltip"
                      ngbTooltip="Hint: For automatic calculation of sea distance the origin and destination should be the cities with (Port)"
                    >
                      <a class="info-icon">
                        <span>
                          <img src="./assets/icons/grey-question-icon.svg" width="14" height="14"
                        /></span>
                      </a>
                    </span>
                  </div>
                  <div class="col-sm-5">
                    <button
                      class="modelBtn setOriginBtn pull-right"
                      *ngIf="!isCheckUpdateOrigin"
                      (click)="setOrigin(getTransportScenarioListForRetail)"
                    >
                      Set origin
                    </button>
                    <button
                      class="modelBtn setOriginBtn pull-right"
                      *ngIf="isCheckUpdateOrigin"
                      (click)="setOrigin(getTransportScenarioListForRetail)"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </ng-template>
              <div
                class="row"
                *ngIf="getTransportScenarioListForRetail?.length > 0 && !checkIsOrginBtn"
              >
                <div class="col-4">
                  <div class="d-flex justify-content-end ms-5">
                    <p
                      class="highlights"
                      [ngClass]="
                        transportationDetailForm.controls['transportModeForLocation'].value
                          ? 'custom-text-position'
                          : ''
                      "
                      placeholder="Origin"
                    >
                      Select locations with "(Port)" for shipping
                    </p>
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  getTransportScenarioListForRetail?.length > 0 && !checkIsOrginBtn;
                  else other_content
                "
                class="row"
              >
                <div class="col-md-4">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <div>
                    <ng-autocomplete
                      #autoForDestination
                      [data]="selectedCities"
                      [searchKeyword]="keyword"
                      historyIdentifier="selectedCities"
                      [itemTemplate]="itemTemplate"
                      (inputChanged)="onSearch($event)"
                      (selected)="selectEvent($event)"
                      class="supplierdrpdown"
                      [notFoundTemplate]="notFoundTemplate"
                      placeholder="Destination"
                      (inputCleared)="onClearSearch($event)"
                      formControlName="destination"
                      [isLoading]="isLoading"
                      (scrolledToEnd)="onScroll()"
                      [(ngModel)]="keywordAuto"
                      (keydown)="onKeyDownEvent($event)"
                    >
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                      <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>

                  <div
                    *ngIf="
                      setDestinationsubmitted &&
                      !this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty(
                        'name'
                      )
                    "
                    class="input-error destinatioErrorMessage"
                  >
                    Select city from list.
                  </div>
                </div>
                <div class="col-md-4" *ngIf="!isCustomTruck">
                  <div class="required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                      class="sub-header-drpdown pb-2"
                      >Transport mode</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="transportModeItems"
                      [searchable]="false"
                      formControlName="transportModeForLocation"
                      (change)="changeTransportMode($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearch"
                      placeholder="Select transport mode"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control accordion-search search-input"
                            id="inputValidation"
                            placeholder="Search..."
                            (input)="select.filter($any($event.target).value)"
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div
                    *ngIf="
                      setDestinationsubmitted &&
                      !transportationDetailForm.controls['transportModeForLocation'].value
                    "
                    class="input-error"
                  >
                    Please select transport mode
                  </div>
                </div>
                <div class="col-md-4" *ngIf="isCustomTruck">
                  <div class="required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                      class="sub-header-drpdown pb-2"
                      >Transport mode</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="customTruckItems"
                      [searchable]="false"
                      formControlName="transportModeForLocation"
                      (change)="changeTransportMode($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearch"
                      placeholder="Select custom truck"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control accordion-search search-input"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div
                    *ngIf="
                      setDestinationsubmitted &&
                      !transportationDetailForm.controls['transportModeForLocation'].value
                    "
                    class="input-error"
                  >
                    Please select transport mode
                  </div>
                </div>
                <div class="col-md-4" *ngIf="isCheckUpdateDestination">
                  <div class="form-group required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <div class="services-form">
                      <input
                        (keydown)="noSpecialKeys($event)"
                        placeholder="Distance"
                        formControlName="distanceManulaLocation"
                      />
                      <label>Distance </label>
                    </div>
                    <div *ngIf="setDestinationsubmitted">
                      <div
                        *ngIf="
                          transportationDetailForm.controls['distanceManulaLocation'].value == 0
                        "
                        class="input-error"
                      >
                        The number of licenses must be greater than 0
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label
                    *ngIf="transportationDetailForm.controls['transportModeForLocation'].value"
                    class="placeholder-sub-header pb-2"
                    >Holder_text</label
                  >
                  <div>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="!isCheckUpdateDestination"
                      (click)="setDestination()"
                    >
                      Add transport leg
                    </button>
                    <button
                      class="modelBtn setOriginBtn"
                      *ngIf="isCheckUpdateDestination"
                      (click)="setDestination()"
                    >
                      Update
                    </button>
                  </div>
                </div>
                <div class="row pt-3" *ngIf="isCustomTruck">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input
                        type="checkbox"
                        class="chkOverview"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="isCalcByPalletOrigin"
                        (change)="calcByPalletOrigin($event)"
                      />
                    </div>
                    <div>
                      <label class="title">Calculation by Pallet load</label>
                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="isCalcByPalletOrigin && isCustomTruck">
                  <div class="col-3">
                    <div class="piqet-field-group textbox-margin" aria-required="true">
                      <label for="palletLoadOrigin" class="sub-header-drpdown pb-2"
                        >Pallet load (tonne) *</label
                      >
                      <div class="services-form form-group">
                        <input
                          formControlName="palletLoadOrigin"
                          type="number"
                          step="0.000000001"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="piqet-field-group textbox-margin" aria-required="true">
                      <label for="palletsInTruckOrigin" class="sub-header-drpdown pb-2"
                        >Pallets in truck *</label
                      >
                      <div class="services-form form-group">
                        <input
                          formControlName="palletsInTruckOrigin"
                          type="number"
                          step="1"
                          (change)="LoadInTruckCalculationOrigin()"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="piqet-field-group textbox-margin" aria-required="true">
                      <label for="loadInTruckOrigin" class="sub-header-drpdown pb-2"
                        >Load in truck (tonne) *</label
                      >
                      <div class="services-form form-group">
                        <input
                          formControlName="loadInTruckOrigin"
                          type="number"
                          step="0.000000001"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="piqet-field-group textbox-margin" aria-required="true">
                      <label for="percentLoadedOrigin" class="sub-header-drpdown pb-2"
                        >Percentage loaded (%) *</label
                      >
                      <div class="services-form form-group">
                        <input
                          formControlName="percentLoadedOrigin"
                          type="number"
                          step="0.000000001"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Distance -->
            <div class="fade show" *ngIf="selectDistance">
              <div class="row my-4">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                  <div class="d-flex checkBoxAlienMent">
                    <div>
                      <input
                        type="checkbox"
                        class="chkOverview"
                        [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="isCustomTruck"
                        (change)="chnageCustomTruck($event)"
                      />
                    </div>
                    <div>
                      <label class="checkbox-style">Custom truck</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div
                    class="d-flex justify-content-start justify-content-sm-start justify-content-md-start justify-content-lg-end justify-content-xl-end justify-content-end"
                  >
                    <div></div>
                    <div *ngIf="showEdit && showCustomTruckAccess">
                      <a class="add-link" target="_blank" routerLink="custom/customTrucks"
                        ><span class="redirectLinkText">Add custom truck</span></a
                      >
                      <a
                        class="setLinkIconPosition"
                        target="_blank"
                        replaceUrl="true"
                        routerLink="custom/customTrucks"
                      >
                        <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                      </a>
                      <span class="setLinkIconPosition" (click)="getCustomTruckList()"
                        ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-div">
                <div
                  *ngrxLet="
                    projectFacde.getTransportScenarioListForDistancePackRetail$ as getTransportScenarioListForDistancePackRetail
                  "
                >
                  <ng-container *ngIf="getTransportScenarioListForDistancePackRetail?.length > 0">
                    <piqet-angular-portlet
                      [columnDefs]="distanceProcessColumnDef"
                      [frameworkComponents]="frameworkComponents"
                      [gridData]="getTransportScenarioListForDistancePackRetail"
                      [hideSearch]="true"
                      [hidePagination]="true"
                      [gridName]="'Project pack retail manual distance'"
                    >
                    </piqet-angular-portlet>
                  </ng-container>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="required" aria-required="true" *ngIf="!isCustomTruck">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                      class="sub-header-drpdown pb-2"
                      >Transport mode</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="transportModeItems"
                      [searchable]="false"
                      formControlName="transportModeForDistance"
                      (change)="changeTransportModeDistance($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearch"
                      placeholder="Select transport mode"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="accordion-search form-control search-input"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div
                    class="formGroupForDistance required"
                    aria-required="true"
                    *ngIf="isCustomTruck"
                  >
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                      class="sub-header-drpdown pb-2"
                      >Transport mode</label
                    >
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="customTruckItems"
                      [searchable]="false"
                      formControlName="transportModeForDistance"
                      (change)="changeTransportModeDistance($event)"
                      bindLabel="name"
                      [searchFn]="commonInputSearch"
                      placeholder="Select transport mode"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control accordion-search search-input search"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div
                    *ngIf="
                      setManualDistanceSubmitted &&
                      !transportationDetailForm.controls['transportModeForDistance'].value
                    "
                    class="input-error"
                  >
                    Please select transport mode
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="form-group required" aria-required="true">
                    <label
                      *ngIf="transportationDetailForm.controls['transportModeForDistance'].value"
                      class="placeholder-sub-header pb-2"
                      >Holder_text</label
                    >
                    <div class="services-form">
                      <input
                        type="number"
                        maxlength="100"
                        placeholder="Component name"
                        min="0"
                        formControlName="distance"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      />
                      <label>Distance</label>
                    </div>
                    <div *ngIf="setManualDistanceSubmitted">
                      <div
                        *ngIf="transportationDetailForm.controls['distance'].value === 0"
                        class="input-error"
                      >
                        The number of licenses must be greater than 0
                      </div>
                    </div>
                    <div
                      *ngIf="
                        setManualDistanceSubmitted &&
                        !transportationDetailForm.controls['distance'].value &&
                        transportationDetailForm.controls['distance'].value !== 0
                      "
                      class="input-error"
                    >
                      please select distance
                    </div>
                  </div>
                </div>
              </div>
              <div class="row my-2" *ngIf="isCustomTruck">
                <div class="d-flex checkBoxAlienMent">
                  <div>
                    <input
                      type="checkbox"
                      (change)="calcByPallet($event)"
                      class="chkOverview"
                      [ngModelOptions]="{ standalone: true }"
                      [(ngModel)]="isCalcByPallet"
                    />
                  </div>
                  <div>
                    <label class="title">Calculation by Pallet load</label>
                  </div>
                </div>
              </div>
              <div class="row mt-3" *ngIf="isCalcByPallet && isCustomTruck">
                <div class="col-3 input-div">
                  <div class="piqet-field-group" aria-required="true">
                    <label for="palletLoad" class="sub-header-drpdown pb-2"
                      >Pallet load (tonne) *</label
                    >
                    <div class="services-form form-group">
                      <input formControlName="palletLoad" type="number" step="0.000000001" />
                    </div>
                  </div>
                </div>
                <div class="col-3 input-div">
                  <div class="piqet-field-group" aria-required="true">
                    <label for="palletsInTruck" class="sub-header-drpdown pb-2"
                      >Pallets in truck *</label
                    >
                    <div class="services-form form-group">
                      <input
                        formControlName="palletsInTruck"
                        (change)="LoadInTruckCalculation()"
                        type="number"
                        step="1"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-3 input-div">
                  <div class="piqet-field-group" aria-required="true">
                    <label for="loadInTruck" class="sub-header-drpdown pb-2"
                      >Load in truck (tonne) *</label
                    >
                    <div class="services-form form-group">
                      <input formControlName="loadInTruck" type="number" step="0.000000001" />
                    </div>
                  </div>
                </div>
                <div class="col-3 input-div">
                  <div class="piqet-field-group" aria-required="true">
                    <label for="percentLoaded" class="sub-header-drpdown pb-2"
                      >Percentage loaded (%) *</label
                    >
                    <div class="services-form form-group">
                      <input formControlName="percentLoaded" type="number" step="0.000000001" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="add-button">
                    <button
                      class="purple-button"
                      *ngIf="!isCheckEditManudalDist"
                      (click)="addTransportDistance()"
                    >
                      Add transport leg
                    </button>
                    <button
                      class="purple-button"
                      *ngIf="isCheckEditManudalDist"
                      (click)="addTransportDistance()"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Custom -->
            <div class="fade show" *ngIf="selectCustom">
              <div class="row mt-3">
                <div>
                  <div class="col-12">
                    <div class="d-flex justify-content-end">
                      <div></div>
                      <div *ngIf="showEdit && showCustomTransportAccess">
                        <a class="add-link" target="_blank" routerLink="custom/customTransport"
                          ><span class="redirectLinkText">Add custom transport scenario</span></a
                        >
                        <a
                          class="setLinkIconPosition"
                          target="_blank"
                          replaceUrl="true"
                          routerLink="custom/customTransport"
                        >
                          <img
                            src="./assets/icons/redirect-icon.svg"
                            alt=""
                            width="15"
                            height="13"
                          />
                        </a>
                        <span class="setLinkIconPosition" (click)="getCustomTransport()"
                          ><img
                            src="./assets/icons/refresh-circle.svg"
                            alt=""
                            width="14"
                            height="13"
                        /></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <label
                    *ngIf="transportationDetailForm.controls['customScenarioItem'].value"
                    class="sub-header-drpdown pb-2"
                    >Selected custom freight scenario</label
                  >
                  <div class="custom-margin required">
                    <ng-select
                      [clearable]="true"
                      [clearOnBackspace]="false"
                      #select
                      [items]="customtransportScenarioItems"
                      [searchable]="false"
                      formControlName="customScenarioItem"
                      bindLabel="name"
                      (change)="changeCustomTransportItem($event)"
                      (clear)="resetTransport()"
                      [searchFn]="commonInputSearch"
                      placeholder="Select custom freight mode"
                    >
                      <ng-template ng-header-tmp>
                        <div class="has-feedback">
                          <input
                            type="text"
                            class="form-control accordion-search search-input"
                            id="inputValidation"
                            (input)="select.filter($any($event.target).value)"
                            placeholder="Search..."
                          />
                          <span class="form-control-feedback">
                            <i class="fa fa-search icon"></i>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                          {{ item.name }}
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <div class="add-button text-margin">
                    <button class="purple-button" (click)="addCustomFreight()">
                      Add transport leg
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-div">
              <div
                *ngrxLet="
                  projectFacde.getCustomTransoportScenarioDetailViewModels$ as getCustomTransoportScenarioDetailViewModels
                "
              >
                <div
                  *ngIf="
                    isShowCustomTransportList ||
                    getCustomTransoportScenarioDetailViewModels?.length > 0
                  "
                >
                  <piqet-angular-portlet
                    [columnDefs]="customTransportDef"
                    [gridData]="customTransportList || getCustomTransoportScenarioDetailViewModels"
                    [hideSearch]="true"
                    [hidePagination]="true"
                    [gridName]="'pack material custom transport'"
                  >
                  </piqet-angular-portlet>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="my-2" />
        <div formGroupName="storageDetailForm">
          <div>
            <label class="subTitleName">Storage process</label>
          </div>

          <div class="row my-2">
            <div class="col-md-6">
              <div class="d-flex checkBoxAlienMent">
                <div>
                  <input
                    type="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="isCustomStorage"
                    class="chkOverview"
                    (change)="changeStorageValue($event)"
                  />
                </div>
                <div>
                  <label class="checkbox-style">Custom storage</label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="d-flex justify-content-end">
                <div></div>
                <div *ngIf="showEdit && showCustomStorage">
                  <a class="add-link" target="_blank" routerLink="custom/customStorage"
                    ><span class="redirectLinkText">Add custom storage</span></a
                  >
                  <a
                    class="setLinkIconPosition"
                    target="_blank"
                    replaceUrl="true"
                    routerLink="custom/customStorage"
                  >
                    <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
                  </a>
                  <span class="setLinkIconPosition" (click)="getCustomStorageList()"
                    ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
                  /></span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label
                  *ngIf="
                    storageDetailForm.controls['storageProcess']?.value ||
                    storageDetailForm.controls['retailLocation']?.value
                  "
                  class="sub-header-drpdown pb-2"
                  >Storage process</label
                >
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  *ngIf="isCustomStorage"
                  class="accordion-text first-letter-capitalize addScroll"
                  #storage
                  [items]="customStorageItems"
                  [searchable]="false"
                  formControlName="storageProcess"
                  bindLabel="name"
                  [searchFn]="commonInputSearch"
                  placeholder="Storage process"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        (input)="storage.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  *ngIf="!isCustomStorage"
                  class="first-letter-capitalize"
                  [items]="storageIdentifierItems"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="storageProcess"
                  [searchFn]="commonInputSearch"
                  placeholder="Storage process"
                  (clear)="clearStorage()"
                  class="accordion-text addScroll"
                  #customStorage
                  (change)="checkStorageProcess($event)"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="customStorage.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group required">
                <label
                  *ngIf="
                    storageDetailForm.controls['storageProcess']?.value ||
                    storageDetailForm.controls['retailLocation']?.value
                  "
                  class="sub-header-drpdown pb-2"
                  >Retail location</label
                >
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  [items]="regionItems"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="retailLocation"
                  [searchFn]="commonInputSearch"
                  placeholder="Country *"
                  class="accordion-text addScroll"
                  #country
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        placeholder="Search..."
                        (input)="country.filter($any($event.target).value)"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="storageDetailForm.controls['retailLocation']?.invalid && finalSubmit"
                  class="input-error"
                >
                  Country is required.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div [ngClass]="isCostTrunOff ? 'form-group' : ''" aria-required="true">
                <piqet-angular-common-input
                  formControlName="storageDays"
                  [control]="storageDetailForm.get('storageDays')"
                  label="Storage days"
                  placeholder="Storage days"
                  inputType="number"
                  [minValue]="0"
                  [maxLength]="10"
                  [preventNegative]="true"
                  [enableRangeValidation]="true"
                  [submitted]="finalSubmit"
                >
                </piqet-angular-common-input>
              </div>
            </div>
            <div class="col-md-6">
              <div aria-required="true">
                <piqet-angular-common-input
                  formControlName="productLoss"
                  [control]="storageDetailForm.get('productLoss')"
                  label="Product loss (%)"
                  placeholder="Product loss (%)"
                  inputType="number"
                  [minValue]="0"
                  [maxValue]="100"
                  [maxLength]="10"
                  [preventNegative]="true"
                  [enableRangeValidation]="true"
                  [submitted]="finalSubmit"
                  [errorMessages]="{
                    required: 'Product loss (%) is required',
                    min: 'Product loss (%) cannot be less than 0',
                    max: 'Product loss (%) cannot be more than 100'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
          </div>
        </div>

        <hr class="mt-5 mb-3" />
        <div formGroupName="productDetailForm">
          <div>
            <label class="subTitleName">Product loss</label>
          </div>

          <div class="row">
            <div [ngClass]="pathName !== 'retail-list' ? 'col-md-6' : 'col-md-6'">
              <div class="custom-margin">
                <label
                  *ngIf="
                    productDetailForm.controls['productLoss']?.value ||
                    productDetailForm.controls['productLossAssociate']?.value
                  "
                  class="sub-header-drpdown pb-2"
                  >Destination of product loss</label
                >
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  class="accordion-text addScroll"
                  #product
                  [items]="productLossWasteDisposalItems"
                  [searchable]="false"
                  formControlName="productLoss"
                  bindLabel="name"
                  [searchFn]="commonInputSearch"
                  placeholder="Destination of product loss"
                  (change)="changeProductLoss($event, 'change')"
                  (clear)="changeProductLoss($event, 'clear')"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        (input)="product.filter($any($event.target).value)"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="finalSubmit && productDetailForm.controls['productLoss']?.invalid"
                  class="input-error"
                >
                  Destination of product loss is required.
                </div>
              </div>
            </div>
            <!-- Condition based secondary market value dropdown starts -->
            <div class="col-6">
              <ng-container *ngTemplateOutlet="packagingDestinationTemplate"></ng-container>
            </div>
          </div>
          <div class="row" *ngIf="secondaryMarketDropdown && pathName === 'retail-list'">
            <div class="col-md-6">
              <div class="form-group required">
                <label
                  *ngIf="
                    productDetailForm.get('secondaryMarket')?.value ||
                    productDetailForm.get('productLoss')?.value ||
                    productDetailForm.get('secondaryMarket')?.value
                  "
                  class="sub-header-drpdown pb-2"
                  >Secondary market percent</label
                >
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  [items]="secondaryMarketValueItem"
                  formControlName="secondaryMarket"
                  bindLabel="name"
                  [searchable]="false"
                  [searchFn]="commonInputSearch"
                  placeholder="Secondary Market Percent"
                >
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <ng-template #packagingDestinationTemplate>
            <div class="form-group">
              <label
                *ngIf="
                  productDetailForm.controls['productLoss']?.value ||
                  productDetailForm.controls['productLossAssociate']?.value
                "
                class="sub-header-drpdown pb-2"
                >Destination of packaging associated with product loss</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                [items]="endofLifeIdentifierItems"
                [searchable]="false"
                bindLabel="name"
                formControlName="productLossAssociate"
                [searchFn]="commonInputSearch"
                placeholder="Destination of packaging associated with product loss"
                class="accordion-text addScroll"
                #productLoss
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="accordion-search form-control search-input"
                      id="inputValidation"
                      placeholder="Search..."
                      (input)="productLoss.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="finalSubmit && productDetailForm.controls['productLossAssociate']?.invalid"
                class="input-error"
              >
                Destination of packaging associated with product loss is required.
              </div>
            </div>
          </ng-template>
        </div>
      </form>
      <div class="setButtonAndError text-margin">
        <div
          class="modal-footer"
          *ngrxLet="{
            getTransportScenarioListForDistancePackRetail:
              (projectFacde.getTransportScenarioListForDistancePackRetail$ | async),
            getTransportScenarioListForRetail:
              (projectFacde.getTransportScenarioListForRetail$ | async),
            getEolTotalError: (projectFacde.getEolTotalError$ | async),
            getTransportScenarioEolDataListForRetail:
              (projectFacde.getTransportScenarioEolDataListForRetail$ | async)
          } as packRetailList"
        >
          <button type="button" class="actionBTN btn btn-light cancelBtn" (click)="onClose()">
            Cancel
          </button>
          <button
            type="button"
            class="actionBTN modelBtn purpleBtnHoverEffect"
            *ngIf="showEdit"
            (click)="
              saveData(
                packRetailList.getTransportScenarioListForDistancePackRetail,
                packRetailList.getTransportScenarioListForRetail,
                packRetailList.getTransportScenarioEolDataListForRetail,
                packRetailList.getEolTotalError
              )
            "
          >
            Save
          </button>
        </div>

        <div class="redErrorTag" *ngIf="finalSubmit && this.projectPackRetailForm.invalid">
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span class="alert-error">To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  class="alert-error"
                  *ngIf="storageDetailForm.controls['retailLocation']?.invalid && finalSubmit"
                >
                  Country
                </div>
              </div>
              <div class="topBottomCss" *ngIf="isStorageProcessValue">
                <div class="alert-error" *ngIf="storageDetailForm.controls['storageDays']?.invalid">
                  Storage days is required
                </div>
                <div
                  class="alert-error"
                  *ngIf="storageDetailForm.controls['productLoss']?.errors?.['required'] "
                >
                  Product loss is required
                </div>
                <div
                  class="alert-error"
                  *ngIf="storageDetailForm.get('productLoss')?.hasError('max')"
                >
                  Product loss cannot exceed 100.
                </div>
              </div>
              <div class="topBottomCss">
                <div class="alert-error" *ngIf="productDetailForm.controls['productLoss']?.invalid">
                  Destination of product loss is required
                </div>
                <div
                  class="alert-error"
                  *ngIf="productDetailForm.controls['productLossAssociate']?.invalid"
                >
                  Destination of packaging associated with product loss is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
